import { useMemo } from 'react';
import { useContent, useFormattedContent } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';
import { TAG_VALUE_TYPE_TO_CID } from 'src/utils/constants/contentIdMaps';
import { FormatContentId } from 'src/utils/constants/formatContentId';
import {
  ActionOutboxEntityType,
  Tag,
  TagsValueType,
} from 'src/WebApiController';

export const useTagMetadataTitle = (
  tagMetadata: Tag,
  entityType: ActionOutboxEntityType
) => {
  const singleValueMsg = useContent(ContentId.SingleValueOnly);
  const dataTypeMsg = useContent(
    TAG_VALUE_TYPE_TO_CID[tagMetadata.valueType ?? TagsValueType.String]
  );

  const metadataTitle = useMemo(() => {
    let title = '';
    if (tagMetadata.singleValueOnly) {
      title += `${singleValueMsg}, `;
    }
    if (dataTypeMsg) {
      title += dataTypeMsg;
    }
    return title;
  }, [tagMetadata.singleValueOnly, singleValueMsg, dataTypeMsg]);

  const inheritedFromText = useFormattedContent(
    entityType === ActionOutboxEntityType.Sale
      ? FormatContentId.InheritedFromListing
      : FormatContentId.InheritedFromPurchase,
    tagMetadata.sourceEntityId?.toString() ?? ''
  ) as string;

  return {
    metadataTitle,
    inheritedFromText:
      tagMetadata.sourceEntityId == null ? undefined : inheritedFromText,
  };
};
